/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { Box, Container, Grid, Typography, useMediaQuery } from "@mui/material";
import RentersForm from "widgets/RentersForm/RentersForm";
import { Navigate, useNavigate } from 'react-router-dom';
import Loader from 'shared/ui/Loader/Loader';
import { FormDataContext } from 'app/providers/formValues/lib/FormDataContext';
import { useCreateTenant, useMutationQuery, useQuoteQuery } from 'entities/Quote/hooks/queries';
import {
	useCustomerDataUpdateMutationQuery,
	useCustomerJourneyMutationQuery,
	useJourneyQuery,
	useJourneyResultFormQuery
} from 'entities/ApplicationForm/hooks/queries';
import { Sidebar } from 'features/CoverageSidebar';
import { FormProvider, useForm } from 'react-hook-form';
import { IFormInput } from '../../app/providers/formValues/ui/FormDataProvider';
import { Plans } from '../../shared/config/enums/formEnums';
import { changeFieldsValue } from '../../shared/utils/changeFieldsValue';
import { Question } from '../../shared/api/assurant/quotePayloadTypes';
import { JourneyResult } from '../../shared/config/types/customerResponse';
import ModalRIQuestion from '../../widgets/RentersForm/ModalRIQuestion';
import ModalNCQuestion from '../../widgets/RentersForm/ModalNCQuestion';
import { ApplicationFormContext } from '../../app/providers/applicationForm/lib/ApplicationFormContext';
import { checkParamType } from '../../shared/utils/checkParamType';
import { normalizeError } from '../../shared/utils/normalizeError';

const QuotePage = () => {
	const { initialPayload, schemaAddress, policyStartDate, setProtections, refInitialData, setFormData, protections } = useContext(FormDataContext);
	const { setApplicationFormData } = useContext(ApplicationFormContext);
	const matchesSM = useMediaQuery('(max-width:900px)');
	const refContainer = useRef<HTMLDivElement | null>(null);
	const { mutate: createNext, isPending, isSuccess, isError, data } = useMutationQuery();

	const { mutate: updateData, isSuccess: fetchSuccess } = useCustomerDataUpdateMutationQuery();
	const query = useJourneyResultFormQuery();
	const { mutateAsync: createOffer } = useCreateTenant()
	const { mutate: fetchForm, mutateAsync: fetchCustomerJourney, isError: isCustomerJourneyError, error: customerJourneyFetchError,  reset: resetCustomerJourneyError } = useCustomerJourneyMutationQuery();
	const queryQuote = useQuoteQuery();
	const journeyData = useJourneyQuery()
	const navigate = useNavigate();
	const methods = useForm<IFormInput>({
		defaultValues: {
			plan: {
				period: Plans.MONTHLY,
				price: '$31.59'
			}
		}
	})
	const {handleSubmit, setValue} = methods
	const hasCalledCreateNext = useRef(false);
	const [questionModal, setQuestionModal] = useState<string | null>(null);
	const [riQuestionAnswer, setRiQuestionAnswer] = useState('');
	const [ncQuestionAnswer, setNCQuestionAnswer] = useState('');
	const [isPendingCoverage, setIsPendingCoverage] = useState(false);
	const [isNeedToCreateOffer, setIsNeedToCreateOffer] = useState(false);
	useEffect(() => {
		const liability = queryQuote?.coverageDetails.parameters.find((item) => item.name === 'liabilityAmount')?.value
		const deductible =  queryQuote?.coverageDetails.parameters.find((item) => item.name === 'deductible')?.value || '250'
		if(liability) {
			setValue('liability', liability)
		}
		if(deductible) {
			setValue('deductible', deductible)
		}
	}, [queryQuote]);


	const onClose = () => {
		setRiQuestionAnswer('')
		setNCQuestionAnswer('')
		setQuestionModal(null)
		resetCustomerJourneyError()
	}
	const urlSearchString = window.location.search;
	const params = new URLSearchParams(urlSearchString);
	const client_id: string = params.get('client_id') || localStorage.getItem('client_id') || "";
	const type: string = params.get('type') || checkParamType(client_id) || "";


	const waterBackup = queryQuote?.coverageDetails.parameters.filter((item) => item.name === "waterBackup")[0];
	const identityFraud = queryQuote?.coverageDetails.parameters.filter((item) => item.name === "identityFraud")[0];
	const earthquake = queryQuote?.coverageDetails.parameters.filter((item) => item.name === "earthquake")[0];
	const replacementCost = queryQuote?.coverageDetails.parameters.filter((item) => item.name === "replacementCost")[0];

	useEffect(() => {
		setProtections(prevState => {
			return {
				...prevState,
				...(waterBackup && { ["waterBackup"]: waterBackup.value || 'N' }),
				...(identityFraud && { ["identityFraud"]: identityFraud.value || 'N' }),
				...(earthquake && { ["earthquake"]: earthquake.value || 'N' }),
				...(replacementCost && { ["replacementCost"]: replacementCost.value || 'N' }),
			}
		});
	}, [waterBackup, identityFraud, earthquake, replacementCost]);

	const handleChangeRI = (event: React.ChangeEvent<HTMLInputElement>) => {
		setRiQuestionAnswer((event.target as HTMLInputElement).value);
	};
	const handleChangeNC = (event: React.ChangeEvent<HTMLInputElement>) => {
		setNCQuestionAnswer((event.target as HTMLInputElement).value);
	};

	useEffect(() => {
		if (schemaAddress.Address1 && query && !refInitialData.current && !hasCalledCreateNext.current) {
			if (initialPayload.transaction.clientId && initialPayload.transaction.workItemId) {
				hasCalledCreateNext.current = true;
				createNext({
					...initialPayload,
					transaction: {
						...initialPayload.transaction,
						policyEffectiveDate: policyStartDate
					},
					policyHolder: {
						...initialPayload.policyHolder,
						insured: {
							address: {
								...initialPayload.policyHolder.insured.address,
								address1: schemaAddress.Address1,
								address2: schemaAddress.Address2,
								city: schemaAddress.City,
								state: schemaAddress.State,
								postalCode: schemaAddress.ZipCode,
							}
						},
					},
					underWriting: {
						questions: [
							...initialPayload.underWriting.questions,
						]
					}
				})
			}
		}
	}, [createNext, schemaAddress, query, initialPayload.transaction.workItemId]);

	useEffect(() => {
		const quoteSuccessRequest = schemaAddress.State === 'RI' || schemaAddress.State === 'NC' ? isSuccess : true
		const error = data?.data.transactionDetails.responseMessage
		if (fetchSuccess && quoteSuccessRequest && !error) {
			fetchForm(client_id)
			if (query) {
				setApplicationFormData(query);
			}
			onClose()
			setIsPendingCoverage(false)
			if(type === 'anonymous') {
				navigate('/questions');
			} else {
				navigate('/checkout');
			}
		}
	}, [fetchSuccess, isSuccess]);

	const needsToCreateNewOffer = (answer: string, propertyMaterial?: string, coverageMasonry?: string, isMasonryConstruction?: string, ) => {
		if(propertyMaterial === 'Wood' && coverageMasonry === 'N' && isMasonryConstruction === 'N' && answer === 'N') {
			return false
		}
		return !(propertyMaterial === 'Masonry' && coverageMasonry === 'Y' && isMasonryConstruction === 'Y' && answer === 'Y');

	}

	const setValueNC = useCallback(() => {
		const isMasonryConstruction = initialPayload.underWriting.questions
			.find((item) => item.questionName === 'isMasonryConstruction')
		setNCQuestionAnswer(isMasonryConstruction?.answer ?? '')
		setQuestionModal('NC')
	}, [initialPayload.underWriting.questions]);

	const onSubmit = () => {
		if (schemaAddress.State === 'RI' && !riQuestionAnswer) {
			setQuestionModal('RI')
			return
		}
		if (schemaAddress.State === 'NC' && !ncQuestionAnswer) {
			setValueNC()
			return
		}
		setIsPendingCoverage(true);
		void handleSubmit(async (data) => {
			try {
			setFormData(data);
			if (query) {
				let underWritingQuestionsData = query.underwriting.questions
				const newCoverageInfoParams = changeFieldsValue(query.coverage_info.parameters, protections, data)
				const quoterResultParams = changeFieldsValue(query.quote_result.coverageDetails.parameters, protections, data)
				let newQuestions: Question[] = []
				if(riQuestionAnswer) {
					newQuestions = [{
						questionName: 'Arson', answer: riQuestionAnswer
					}]
					underWritingQuestionsData = initialPayload.underWriting.questions.filter((item) => item.questionName !== 'Arson')
				}
				const underwritingQuestions = newQuestions.length > 0 ? [
					...underWritingQuestionsData, ...newQuestions
				] : initialPayload.underWriting.questions
				const queryData: JourneyResult = {
					...query,
					coverage_info: {
						...query.coverage_info,
						effective_date: policyStartDate,
						parameters: newCoverageInfoParams
					},
					quote_result: {
						...query.quote_result,
						transactionDetails: {
							...query.quote_result.transactionDetails,
							policyEffectiveDate: policyStartDate,
						},
						coverageDetails: {
							parameters: quoterResultParams
						},
					},
					underwriting: {
						questions: underwritingQuestions
					}
				}
				if(schemaAddress.State === 'RI' || schemaAddress.State === 'NC') {
					const newPayload = {
						...initialPayload,
						underWriting : {
							questions: underwritingQuestions
						},
					}
					if(schemaAddress.State === 'RI') {
						await createNext(newPayload)
					}
					if(schemaAddress.State === 'NC'){
						const coverageMasonry = initialPayload.underWriting.questions
							.find((item) => item.questionName === 'coverageMasonry')
						const isMasonryConstruction = initialPayload.underWriting.questions
							.find((item) => item.questionName === 'isMasonryConstruction')
						const isNeedToCreateNewOffer = needsToCreateNewOffer(
							ncQuestionAnswer,
							journeyData?.journeyResult.property_info.property_material,
							coverageMasonry?.answer,
							isMasonryConstruction?.answer,
						)
						setIsNeedToCreateOffer(isNeedToCreateNewOffer)
						if(isNeedToCreateNewOffer) {
							const customerResponseAxiosResponse = await fetchCustomerJourney(localStorage.getItem('client_id')!)
							const parsedCustomerJourney = JSON.parse(customerResponseAxiosResponse.data.journeyResult)
							const parsedCustomerInfo = JSON.parse(parsedCustomerJourney.customer.quoteRequest)
							const newPayload = {
								...parsedCustomerInfo,
								PropertyInfo: {
									...parsedCustomerInfo.PropertyInfo,
									PropertyMaterial: ncQuestionAnswer === 'Y' ? 'Masonry' : 'Wood'
								},
								TenantInfo: {
									...parsedCustomerInfo.TenantInfo,
									DateOfOccupancy: policyStartDate
								},
							}
							const offer = await createOffer(newPayload)
							if(offer.data){
								const newUrl = location.protocol + '//' + location.host + location.pathname
								const typeString = type=='anonymous' ? `&type=anonymous` : ''
								window.location.href = `${newUrl}?client_id=${offer.data.referenceId as unknown as string}${typeString}`
							}
						} else {
							await createNext(newPayload)
						}
					}
				}
				if (journeyData) {
					updateData({
						customerJourneyId: journeyData.customerJourneyId,
						stageName: "QuoteCreated",
						stageId: "",
						model: JSON.stringify(queryData),
					})
				}
			}} catch (error) {
				console.error('Error submitting form:', error);
				setIsPendingCoverage(false)
			}
		})()
	}

	if (isError && !isPending) {
		return <Navigate to="/error"/>;
	}
	return (
		<Grid container position="relative" minHeight={isPending ? '600px' : 'auto'}>
			{isPending && <Loader />}
			{isSuccess && queryQuote && !isPending && (
				<FormProvider {...methods}>
					<Grid size={{ xs: 12, md: 8, lg: 8, sm: 12 }}>
						<Container maxWidth={"md"} sx={{ mt: 5 }}>
							<Typography variant={"h3"} align={"center"} sx={{ mb: 0 }}>Your Renters Insurance</Typography>
							<Typography variant={"body1"} align={"center"} color="darkGrey.secondary">
								You and your belongings are protected from a variety of incidents, even if you’re
								travelling.
							</Typography>
							<Box sx={{ mb: 2 }}>
								{isSuccess && <RentersForm onSubmit={onSubmit} loading={isPendingCoverage}/>}
							</Box>
						</Container>
					</Grid>
					<Grid size={{ xs: 12, md: 4, lg: 4, sm: 12 }} width={"100%"}>
						<Container sx={{ mt: 5, width: '100%' }} ref={refContainer} maxWidth={"md"}>
							{!matchesSM && <Sidebar refContainer={refContainer} onSubmit={onSubmit} loading={isPendingCoverage}/>}
						</Container>
					</Grid>
				</FormProvider>
			)
			}
			{questionModal === 'RI' && (
				<ModalRIQuestion
					questionModal={questionModal === 'RI'}
					onClose={onClose}
					questionAnswer={riQuestionAnswer}
					handleChange={handleChangeRI}
					onSubmit={onSubmit}
					isPending={isPendingCoverage}
					isErrorTenantFetch={isCustomerJourneyError}
					errorMessage={normalizeError(customerJourneyFetchError)}
				/>)}
			{questionModal === 'NC' && (
				<ModalNCQuestion
					questionModal={questionModal === 'NC'}
					onClose={onClose}
					questionAnswer={ncQuestionAnswer}
					handleChange={handleChangeNC}
					onSubmit={onSubmit}
					isPending={isPendingCoverage}
					isNeedToCreateOffer={isNeedToCreateOffer}
					isErrorTenantFetch={isCustomerJourneyError}
					errorMessage={normalizeError(customerJourneyFetchError)}
				/>)}
		</Grid>
	)
}

export default QuotePage
